import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface VideoViewerDialogData {
  title?: string
  video: {
    src: string,
    type?: string,
  }
}

@Component({
  host: {
    class: 'mat-dialog-component',
    'test-id': 'video-viewer-dialog',
  },
  selector: 'video-viewer-dialog',
  styles: [`
    :host > div {
      width: 90vw;
      height: 'fit-content';
    }
    video {
      width: 100%;
      max-height: 100%;
    }
  `],
  template: `
    <h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
    <button test-id="modal-close-button" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    <div>
      <video controls autoplay preload="auto">
        <source *ngIf="videoType" [src]="videoSrc" [type]="videoType">
        <source *ngIf="!videoType" [src]="videoSrc">
        Your browser does not support the video tag.
      </video>
    </div>
  `,
})
export class VideoViewerDialog {
  public title: string
  public videoSrc: SafeResourceUrl
  public videoType?: string

  constructor(
  @Inject(MAT_DIALOG_DATA) data: VideoViewerDialogData,
    sanitizer: DomSanitizer,
  ) {
    this.title = data.title;
    this.videoSrc = sanitizer.bypassSecurityTrustResourceUrl(data.video.src);
    this.videoType = data.video.type;
  }
}
